import gql from 'graphql-tag';
import apollo from '../apollo';

const removeExecutiveReportQuery = gql`
  mutation deleteExecutiveReport($id: ID!) {
    deleteExecutiveReport(id: $id) {
      executiveReportId
    }
  }
`;
export const removeReport = id => apollo
  .mutate({
    mutation: removeExecutiveReportQuery,
    variables: {
      id,
    },
  })
  .then(res => res.data);

export const ADD_EXEC_REPORT_MUTATE = gql`
  mutation createExecutiveReport($input: CreateExecutiveReportInput!) {
    createExecutiveReport(input: $input) {
      id
      teamName
    }
  }
`;

export const createExecutiveReport = input => apollo
  .mutate({
    mutation: ADD_EXEC_REPORT_MUTATE,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const UPDATE_EXEC_REPORT_MUTATE = gql`
  mutation($input: UpdateExecutiveReportDetailsInput!) {
    updateExecutiveReportDetails(input: $input) {
      id
      teamName
      executiveReportSurveys {
        id
      }
      numberOfSurveys
    }
  }
`;

export const updateExecutiveReport = input => apollo
  .mutate({
    mutation: UPDATE_EXEC_REPORT_MUTATE,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const UPDATE_EXEC_REPORT_SURVEYS = gql`
  mutation($input: UpdateExecutiveReportSurveysInput!) {
    updateExecutiveReportSurveys(input: $input) {
      id
      teamName
      executiveReportSurveys {
        id
      }
      numberOfSurveys
    }
  }
`;

export const updateExecutiveReportSurveys = input => apollo
  .mutate({
    mutation: UPDATE_EXEC_REPORT_SURVEYS,
    variables: {
      input,
    },
    refetchQueries: ['executiveReportSurveyQuery'],
  })
  .then(res => res.data);

export const DEL_EXEC_REPORT = gql`
  mutation($input: DeleteExecutiveReportInput!) {
    deleteExecutiveReport(input: $input) {
      accountId
    }
  }
`;

export const deleteExecutiveReport = input => apollo
  .mutate({
    mutation: DEL_EXEC_REPORT,
    refetchQueries: ['ExecutiveReports'],
    variables: {
      input,
    },
  })
  .then(res => res.data);
